(ns frontend.view.settings.sys-admin.tenants
  (:require-macros [frontend.macros :refer [without-default-action]])
  (:require
   [common.localization :as loc]
   [frontend.view.settings.db :as db]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.view.settings.sys-admin.events :as events]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [ui.components.toggle.view :as toggle]
   ))

(defn tenant-view
  [{:keys [tenant]}]
  (let [{:keys [db/id tenant/name
                tenant/number-of-enabled-users
                tenant/number-of-deals
                tenant/number-of-disabled-users
                tenant/is-paying
                tenant/price-per-month-per-user
                tenant/price-per-tenant
                tenant/payment-method
                tenant/tenant-id-number
                common/disabled?
                tenant/product-plan
                common/hubspot-id
                common/created-on
                common/disabled-on]}
        tenant]
    [:tr
     {:class-name (fu/cs "settings-table-row" (when (:common/disabled? tenant) "disabled-entity"))}
     [:td.settings-table__cell
      [:a
       {:href     "#"
        :on-click (without-default-action
                   (routing/set-view! [:settings-tenant :id id]))}
       name]]
     [:td.settings-table__cell (:db/id tenant)]
     [:td.settings-table__cell (:tenant/tenant-id-number tenant)]
     [:td.settings-table__cell (str (boolean (:common/disabled? tenant)))]
     [:td.settings-table__cell (:plan/type product-plan)]
     [:td.settings-table__cell hubspot-id]
     ;;[:td.settings-table__cell is-paying]
     ;;[:td.settings-table__cell number-of-enabled-users]
     ;;[:td.settings-table__cell number-of-disabled-users]
     ;;[:td.settings-table__cell number-of-deals]
     ;;[:td.settings-table__cell (when (> created-on 0) (utils/format-date-ts created-on))]
     ;;[:td.settings-table__cell (when (> disabled-on 0) (utils/format-date-ts disabled-on))]
     ;;[:td.settings-table__cell price-per-month-per-user]
     ;;[:td.settings-table__cell price-per-tenant]
     ;;[:td.settings-table__cell payment-method]
    ]))

(defn show-archived-checkbox
  []
  (let [show-archived? (events/show-archived?)]
    [:span
     {:class "flex items-center gap-2"}
     (loc/tr :show-archived)
     [toggle/toggle
      {:checked?   show-archived?
       :on-change (fn [_] (events/toggle-archived))}]]))

(defn options-bar
  []
  [:div.zap-options-bar
   [:div.zap-options-bar-left
    [:a.settings-tenant__new-tenant
     {:href     "/settings/new-tenant"
      :on-click (without-default-action
                 (routing/set-view! [:settings-new-tenant]))}
     (loc/tr :add-tenant)]]
   [:div.zap-options-bar-right
    [:div.zap-options-bar-card-mode
     [show-archived-checkbox]]]])

(defn view
  []
  (let [{:keys [entities]} @db/state
        show-archived? (events/show-archived?)
        entities-seq (vals entities)
        tenants (->> entities-seq
                     (filter #(= :entity.type/tenant (:entity/type %)))
                     (filter #(if show-archived? true (not (:common/disabled? %))))
                     (sort-by :common/created-on)
                     (reverse))]
    (if (or (session/sys-admin?)
            (session/zadmin?))
      [:div.settings-tenants
       [:h1.settings__header (loc/tr :tenants)]
       [options-bar]
       [:div.settings-tenants__table-container
        [:table.zap-simple-table.table-striped
         [:thead
          [:tr
           [:th (loc/tr :tenant/name)]
           [:th (loc/tr :db/id)]
           [:th (loc/tr :tenant/tenant-id-number)]
           [:th (loc/tr :common/disabled?)]
           [:th (loc/tr :plan)]
           [:th (loc/tr :common/hubspot-id)]
           ;;[:th.settings-table__cell (loc/tr :tenant/is-paying)]
           ;;[:th.settings-table__cell (loc/tr :tenant/number-of-enabled-users)]
           ;;[:th.settings-table__cell (loc/tr :tenant/number-of-disabled-users)]
           ;;[:th.settings-table__cell (loc/tr :tenant/number-of-deals)]
           ;;[:th.settings-table__cell (loc/tr :common/created-on)]
           ;;[:th.settings-table__cell (loc/tr :common/disabled-on)]
           ;;[:th.settings-table__cell (loc/tr :tenant/price-per-month-per-user)]
           ;;[:th.settings-table__cell (loc/tr :tenant/price-per-tenant)]
           ;;[:th.settings-table__cell (loc/tr :tenant/payment-method)]
          ]]
         [:tbody.settings-table-body
          (doall (for [tenant tenants]
                   [tenant-view
                    {:key    (:db/id tenant)
                     :tenant tenant}]))]]]])))
